/// <reference path="../lib/jquery.d.ts" />

import {Controller} from "./helpers/controller";

export class AccordionControl  extends Controller{
    
    private accordionToggleElementMobOnly: JQuery = $('.accordionToggleMobOnly');
    private window: JQuery = $(window);
        
    constructor(element: HTMLElement) {
        super(element);

        $(element).on('click', (e)=>{
            
            if (element.className.includes("accordionToggleMobOnly") 
                    && window.matchMedia("(min-width: 1024px)").matches) {
                return;
            }
            else {
                let currentElement = $(e.currentTarget);
                currentElement.toggleClass("open");
                currentElement.next().toggle();
            }
        });
        
        this.correctDesktopShowState();
        
        this.window.resize(() => {
            this.correctDesktopShowState();
        });
        
    }
    
    correctDesktopShowState() {
        if (window.matchMedia("(min-width: 1024px)").matches) {
            this.accordionToggleElementMobOnly.next().show();
            this.accordionToggleElementMobOnly.addClass("open");
        } else {
            this.accordionToggleElementMobOnly.next().hide();
            this.accordionToggleElementMobOnly.removeClass("open");
        }
    }
}